import React, { useMemo, useState, useContext, Fragment, useRef, useEffect } from 'react';
import Rimg from './Rimg.jsx';
import './ProductContext.jsx';
import ProductContext from './ProductContext.jsx';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

const ColorThumb = (props) => {
  const { thumb, option1, product, _changeColor, _changeProduct, delegate } = props;
  const productContext = useContext(ProductContext);
  const linkRef = useRef(null);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    
    
    _changeProduct(e, thumb);
  };
  const handleMouseEnter = () => {
    // Only change color on hover for non-touch devices
    if (!isTouchDevice) {
      _changeColor(thumb);
    }
  };

  const option1Index = product.options_with_values[0].values.findIndex(v => v === option1) || 0;
  const option1En = product.en.options_with_values[0].values[option1Index] || product.en.options_with_values[0].values[0];
  const cName = classNames('product-color', {
    'current-color': product.handle === thumb.handle || (delegate && thumb.handle === delegate),
    'incompatible-width': (option1En && option1En.startsWith('Wide') && !thumb.tags.includes(`width:${option1En}`)) || (option1En && option1En.startsWith('Narrow') && !thumb.tags.includes(`width:${option1En}`)),
    'sold-out': !thumb.available && !thumb.tags.includes('no-waitlist-overlay'),
    'lg-thumb': product.tags.includes('dt-lgthumbs')
  });
  const messageTag = thumb.tags.find(tag => tag.startsWith('message:'));
  let thumbMessage = null;
  if (messageTag) {
    thumbMessage = messageTag.replace('message:', '');
  } else if (!thumb.available && !thumb.tags.includes('no-waitlist-overlay')) {
    if (thumb.tags.includes('BIS')) {
      thumbMessage = productContext.i18n.waitlist;
    } else {
      thumbMessage = productContext.i18n.soldOut;
    }
  }

  return <Fragment>
    <a  ref={linkRef} href={`/products/${thumb.handle}`} title={thumb.title} className={cName} data-no-instant  onMouseEnter={handleMouseEnter} onClick={handleClick}>
      <Rimg src={thumb.media.preview_image.src} width={thumb.media.preview_image.width} height={thumb.media.preview_image.height} loading="lazy" alt={thumb.title} sizes="(min-width: 1351px) 54px, (min-width: 1200px) 4.75vw, (min-width: 961px) 5.5vw, (min-width: 721px) 6vw, (min-width: 481px) 10vw, 16vw" />
      {thumbMessage && <span className="thumbnail-message">{thumbMessage}</span>}
    </a>
    {thumb.tags.includes('break-thumb') ? <br /> : null}
    {thumb.tags.includes('mobile-break') ? <br className="desktop--hide" /> : null}
    {thumb.tags.includes('desktop-break') ? <br className="mobile--hide" /> : null}
  </Fragment>
}

const ThumbGroup = (props) => {
  const { thumbGroup, colorName, _changeColor, _changeProduct, product, option1, isLast, delegate } = props;
  const ref = useRef(null);
  const cName = classNames('product-colors', {
    last: isLast,
    'has-name': colorName
  });

  useEffect(() => {
    if (ref.current) {
      const target =  ref.current.querySelector('.current-color');
      if (target) {
        if (target.offsetLeft + target.offsetWidth > ref.current.offsetWidth) {
          ref.current.scrollTo({ left: target.offsetLeft - ref.current.offsetWidth + target.offsetWidth });
        }
      }
    }
  }, [ref.current]);

  return (
    <div className={cName} ref={ref}>
      {colorName && (
        <div className="option-header sub-group">
          <span className="option-color-name">
            {colorName}
          </span>
        </div>
      )}
      {thumbGroup.products.map((thumb, i) => {
        return <ColorThumb key={i} thumb={thumb} option1={option1} product={product} _changeColor={_changeColor} _changeProduct={_changeProduct} delegate={delegate} />
      })}
    </div>
  )
}

const ProductColors = (props) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 720px)' });
  const [currentColor, setCurrentColor] = useState(props.product);
  const [showAllProductColors, setShowAllProductColors] = useState(false);
  let userHasClicked = false;

  const ColorLabel = () => {
    if (currentColor.title.includes('|')) {
      return <div className="option-header">
        <span className="option-color-name">
          Color:
        </span>
        <span className="option-color-value">
          {currentColor.color_label ? ` ${currentColor.color_label}` : currentColor.title.split('|')[1]}
        </span>
      </div>
    }
    return null;
  };

  const _changeColor = (color) => {
    if (userHasClicked) {
      return;
    }
    setCurrentColor(color);
    props.onColorChange(color);
  }

  const _changeProduct = (e, newProduct) => {
    userHasClicked = true;
    e.preventDefault();
    props.onProductChange(newProduct, props.currentVariant);
  }


  let productGroup = (showAllProductColors && props.productGroup.length > 1) ? props.productGroup : props.productGroup.slice(0, props.metafields.thumbnails.limit);
  let colorName = props.metafields.colorName;

  if (isDesktop && props.desktopProductGroup.length > 0) {
    productGroup = (showAllProductColors && props.desktopProductGroup.length > 1) ? props.desktopProductGroup : props.desktopProductGroup.slice(0, props.metafields.thumbnails.desktop_limit);
    colorName = props.metafields.desktopColorName;
  }

  return (
    <div>
      <div className="product-colors-wrapper" onMouseLeave={e => { _changeColor(props.product) }}>
        <ColorLabel />
        {productGroup.map((thumbGroup, i) => {
          const isLast = i === productGroup.length - 1;
          return <ThumbGroup key={i} thumbGroup={thumbGroup} colorName={colorName[`group_${i + 1}`]} product={props.product} option1={props.option1} _changeColor={_changeColor} _changeProduct={_changeProduct} isLast={isLast} delegate={props.delegate} />
        })}
      </div>
      {/* if limit === productGroup length either the limit wasn't set, or it's equal to the number of thumbnail groups anyways  */}
      {props.metafields.thumbnails.limit && props.metafields.thumbnails.limit !== 0 && productGroup.length !== props.metafields.thumbnails.limit && (<button type="button" id="toggle-show-more" className="option-header" onClick={() => (setShowAllProductColors(!showAllProductColors))}> {showAllProductColors ? 'Show fewer styles' : '+ Expand to see more styles'}</button>)}
    </div>
  )
};

export default ProductColors;